import { blue, textMuted, white } from '@/theme/colors'
import styled from 'styled-components'

export const StatGroup = styled.div`
	display: flex;
	gap: 1rem;
	margin-bottom: 1.5rem;
	flex-wrap: wrap;
`

export const StatCard = styled.div`
	background-color: ${white};
	border-radius: 12px;
	padding: 1rem 1.25rem;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
	min-width: 150px;
`

export const StatValue = styled.div`
	font-size: 1.75rem;
	font-weight: 700;
	color: ${blue};
	line-height: 1.1;
	font-variant-numeric: tabular-nums;
`

export const StatLabel = styled.div`
	font-size: 0.85rem;
	color: ${textMuted};
	margin-top: 0.25rem;
`
